import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    registered(registration) {
      console.log('Service worker has been registered.');
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated(registration) {
      console.log('New content is available; please refresh.');
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });
}

function waitForServiceWorkerReady(timeout = 5000) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('Service Worker ready timeout exceeded.'));
    }, timeout);

    navigator.serviceWorker.ready
      .then((registration) => {
        clearTimeout(timer);
        resolve(registration);
      })
      .catch((error) => {
        clearTimeout(timer);

        reject(new Error(`Service Worker failed to become ready: ${error}`));
      });
  });
}

export async function clearCache(): Promise<void> {
  if (!('serviceWorker' in navigator)) {
    console.warn('Service Workers are not supported — skipping cache clear.');
    return;
  }

  try {
    const registration = (await waitForServiceWorkerReady(2000)) as ServiceWorkerRegistration;

    if (registration && registration.active) {
      registration.active.postMessage({ type: 'CLEAR_CACHE' });

      const cacheNames: string[] = await caches.keys();
      await Promise.all(cacheNames.map((name: string) => caches.delete(name)));

      console.log('Cache cleared!');
    }
  } catch (error) {
    console.warn('Service Worker not ready — skipping cache clear.', error);
  }
}
